import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Chip, makeStyles, Typography } from '@popmenu/common-ui';
import { traitLabel } from '../ProfilePage/formatTasteTrait';

const useStyles = makeStyles(theme => ({
  // Pill-shaped like eat's buttons
  chip: {
    borderRadius: theme.spacing(2),
    fontSize: '0.8125rem',
    fontWeight: 600,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  lead: {
    color: theme.palette.text.secondary,
    fontSize: '0.8125rem',
  },
  // The lead always sits above the chips, so cards line up however many chips fit on a line
  reasons: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}));

type TasteMatchChipsProps = {
  traits: { feature: string, isConfident: boolean }[]
}

// Chips for the diner's likes that a dish shows. Matches come back all confident or all still being learned, which get
// the softer lead. Nothing for a dish without any.
export const TasteMatchChips = ({ traits }: TasteMatchChipsProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const labels = traits.flatMap(({ feature }) => traitLabel(intl, feature) ?? []);
  const isConfident = traits.every(trait => trait.isConfident);

  if (labels.length === 0) return null;

  return (
    <Box className={classes.reasons}>
      <Typography className={classes.lead} component="span">
        {isConfident ? <FormattedMessage defaultMessage="You like" /> : <FormattedMessage defaultMessage="You might like" />}
      </Typography>
      <Box className={classes.chips} component="ul">
        {labels.map(label => (
          <li key={label}>
            <Chip className={classes.chip} label={label} size="small" variant={isConfident ? 'default' : 'outlined'} />
          </li>
        ))}
      </Box>
    </Box>
  );
};
